import { Outlet } from 'react-router-dom';
import { PageLoadingSpinner } from 'shared/components/LoadingSpinner/PageLoadingSpinner';
import { useRemoteDictionariesQuery } from 'shared/hooks/api/remoteDictionaries/remoteDictionaries.generated';

export const DataFetchContainer = () => {
  const { loading } = useRemoteDictionariesQuery();

  if (loading) {
    return <PageLoadingSpinner />;
  }

  return <Outlet />;
};
